<script setup lang="ts">
import { useCounterStore } from '@/stores/counter';
import { useOnboardingStore } from '@/stores/onboarding';
import type { IOnboardingStep } from '@/types/IAssetType';
import { RadioGroup, RadioGroupOption, DialogTitle } from '@headlessui/vue'
import { ref, watch } from 'vue';
import { CheckCircleIcon } from '@heroicons/vue/20/solid'

import InputNumber from "primevue/inputnumber"
const onboardingStore = useOnboardingStore()
const store = useCounterStore()

const myStep = ref(onboardingStore.steps.find(x => x.tag === 'AddCashAccount') as IOnboardingStep)

watch(
    () => [onboardingStore.stepsData.addCashAccountComponent],
    () => {
        myStep.value.canGoNext =
            (onboardingStore.stepsData.addCashAccountComponent.accountName !== undefined && onboardingStore.stepsData.addCashAccountComponent.accountName !== null && onboardingStore.stepsData.addCashAccountComponent.accountName.length >= 2)
            &&
            (onboardingStore.stepsData.addCashAccountComponent.currency !== undefined && onboardingStore.stepsData.addCashAccountComponent.currency.length > 0)
            &&
            (onboardingStore.stepsData.addCashAccountComponent.currentBalance !== undefined && onboardingStore.stepsData.addCashAccountComponent.currentBalance !== null && onboardingStore.stepsData.addCashAccountComponent.currentBalance >= 0)

    },
    { deep: true }
)

</script>

<template>
    <div class=" bg-slate-300 -mx-4 -mt-5 sm:-m-6  p-4 sm:px-6 sm:py-4 ">
        <h3 class="text-base font-semibold leading-6 text-gray-900">Add a cash account</h3>
        <p class="mt-0 max-w-4xl text-sm text-gray-500">Please enter information below.</p>
    </div>

    <div class="mt-10 mb-6">
        <div class="space-y-12">
            <div class="grid grid-cols-12 gap-x-4 gap-y-6 sm:grid-cols-12">
                <div class="col-span-8">
                    <label for="accountname" class="block text-sm font-medium leading-6 text-gray-900">Bank name</label>
                    <div class="mt-2">
                        <input v-model="onboardingStore.stepsData.addCashAccountComponent.accountName" id="accountname" name="accountname" type="text" autocomplete="off"
                            class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                    </div>
                    <p class="mt-1 text-sm leading-6 text-gray-600">Example: Bank of America, QNB.</p>
                </div>


                <fieldset class="col-span-12">
                    <legend class="text-sm font-semibold leading-6 text-gray-900">Currency</legend>
                    <RadioGroup v-model="onboardingStore.stepsData.addCashAccountComponent.currency" class="mt-2 grid grid-cols-3 sm:gap-y-4 gap-y-2 sm:grid-cols-3 gap-x-4">
                        <RadioGroupOption as="template" v-for="currency in store.currencies" :key="currency.code" :value="currency.code" :aria-label="currency.name"
                            :aria-description="`${currency.name} to ${currency.code}`" v-slot="{ active, checked }">
                            <div
                                :class="[active ? 'border-indigo-600 ring-2 ring-indigo-600' : 'border-gray-300', 'relative flex cursor-pointer rounded-lg border bg-white p-4 shadow-sm focus:outline-none']">
                                <span class="flex flex-1">
                                    <span class="flex flex-col">
                                        <span class="block text-sm font-medium text-gray-900">{{ currency.code }}</span>
                                        <span class="mt-1 flex items-center text-xs text-gray-500">{{ currency.name }}</span>
                                        <!-- <span class="mt-6 text-sm font-medium text-gray-900">{{ buyOrSell.description }}</span> -->
                                    </span>
                                </span>
                                <CheckCircleIcon :class="[!checked ? 'invisible' : '', 'h-5 w-5 text-indigo-600']" aria-hidden="true" />
                                <span :class="[active ? 'border' : 'border-2', checked ? 'border-indigo-600' : 'border-transparent', 'pointer-events-none absolute -inset-px rounded-lg']"
                                    aria-hidden="true" />
                            </div>
                        </RadioGroupOption>
                    </RadioGroup>
                </fieldset>

                <div class="col-span-8">
                    <label for="curbalance" class="block text-sm font-medium leading-6 text-gray-900">Current balance</label>
                    <div class="mt-2">
                        <!-- <input v-model.number="onboardingStore.stepsData.addCashAccountComponent.currentBalance" id="curbalance" name="curbalance" type="number" autocomplete="off"
                            class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" /> -->

                        <div class="mt-2 max-w-xs">
                            <InputNumber v-model="onboardingStore.stepsData.addCashAccountComponent.currentBalance" mode="currency"
                                :currency="onboardingStore.stepsData.addCashAccountComponent.currency" inputId="integeronly" :minFractionDigits="2" :maxFractionDigits="2" />
                        </div>
                    </div>
                    <p class="mt-1 text-sm leading-6 text-gray-600">Example: 300</p>
                </div>
            </div>
        </div>
    </div>


</template>